import React from "react";
import { useLocation } from "react-router-dom";
import { CONTACT } from "../../mock";

const WaIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
    <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35zM12.04 21.5h-.01a9.4 9.4 0 0 1-4.8-1.31l-.34-.2-3.57.93.95-3.48-.22-.36a9.43 9.43 0 1 1 8 4.42zm8.03-17.46A11.32 11.32 0 0 0 12.04.7C5.79.7.7 5.79.7 12.04c0 2 .52 3.95 1.52 5.67L.6 23.3l5.72-1.5a11.3 11.3 0 0 0 5.71 1.46h.01c6.25 0 11.34-5.09 11.34-11.34 0-3.03-1.18-5.88-3.31-8.02z" />
  </svg>
);

const WhatsAppButton = () => {
  const { pathname } = useLocation();
  const onBook = pathname.startsWith("/book");
  if (pathname.startsWith("/admin")) return null;
  return (
  <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" data-testid="whatsapp-float"
    className={`${onBook ? "hidden lg:flex" : "flex"} fixed bottom-4 right-4 sm:bottom-5 sm:right-5 z-40 items-center gap-2 rounded-full bg-[#25D366] text-white p-3 sm:pl-3.5 sm:pr-5 sm:py-3 shadow-[0_10px_30px_-8px_rgba(37,211,102,.6)] hover:bg-[#1FBF5B] hover:-translate-y-0.5 transition-[background-color,transform] duration-200`}>
    <WaIcon />
    <span className="font-semibold text-[15px] hidden sm:inline">WhatsApp</span>
  </a>
  );
};

export default WhatsAppButton;
